import styled from "styled-components";
export const HomeWrapper = styled.div`
  transition: margin-left .2s ease-in;
  padding: 50px 0px 50px 80px;
  max-width: 800px;
  box-sizing: border-box;
  background:#fff;
  height:100vh;
  margin-left: 200px;
`
export const Option = styled.option`
  padding: 5px;
  cursor: pointer;
`

export const DropdownWrapper = styled.div`
    display: flex;
    padding-left: 13px;
    padding-right: 13px;
    align-items: center;
    border: ${props => `1px solid ${props.theme.primaryColor}`};
    color: ${props => props.theme.baseColor};
    display: flex;
    flex-direction: row;
    justify-content: right;
    height: 50px; 
    width: 50%;
    border-radius: 4px;
    align-items: center;
    margin-bottom: 30px;
`
export const AgeWrapper = styled.select`
    display: flex;
    width: 100%;
    padding: 1.2rem;
    cursor: pointer;
    border: none;
    font-size: 14px;
    color: ${props => props.theme.defaultFontColor};
    font-weight: 200;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: 0.25px;
    background-color: transparent;
    -webkit-appearance: none;
    &:hover,
    &:focus 
    {
      outline: 0 !important;
    };
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: flex-end;
  padding: 20px 0px;
`

export const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`
